import { useEffect, useState } from "react";
import api from "./api";

// Cache module-level : la stat "confiance élevée" est partagée par toutes les
// cartes (une seule requête réseau pour toute la page).
let _cache = null;
let _promise = null;

export function useHighConfidence() {
  const [hc, setHc] = useState(_cache);
  useEffect(() => {
    if (_cache) { setHc(_cache); return; }
    if (!_promise) {
      _promise = api.get("/performance/high-confidence")
        .then((r) => { _cache = r.data; return r.data; })
        .catch(() => { _promise = null; return null; });
    }
    _promise.then((d) => setHc(d));
  }, []);
  return hc;
}
